/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="textelBlast.module.ts" />
/// <reference path="../../components/short-cuts/index.d.ts"/>


module Meevo.Plugins.TextelBlast{

    class TextelBlastController extends Meevo.Components.CommonClasses.CommonControllerBase{

        context: TextelBlastContext;

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "$rootScope",
            "$timeout",
            "$state",
            'meevo.ContextParams',
            "meevo.components.tracking.TrackingService",
            "$scope",
            "meevo.components.short-cuts.ShortCutsService",
            "$translate",
            "$window"
        ];



        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected $rootScope: angular.IRootScopeService,
            protected $timeout: ng.ITimeoutService,
            protected $state: any,
            protected contextParams: any,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $scope: ng.IScope,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected $translate: angular.translate.ITranslateService,
            protected $window: angular.IWindowService
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService)

            this.context = new TextelBlastContext(appSettings, dataService, modalService, trackingService, identityService, $translate, loggingService, securityService, $window);
        }
    }

    angular.module('meevo.plugins.textelBlast')
        .controller('meevo.plugins.textelBlast.TextelBlastController', TextelBlastController);
}
